import {
  CONTRACT_AUTHENTICATION_INITIALIZE,
  PARTICIPANT_SET_INFORMATION,
  PARTICIPANT_STATUS_SUCCESS,
} from '@app/store/actionTypes';
import { ContractAuthenticationAction } from '@app/store/contract-authentication/actions';

import { ParticipantAction } from '../actions';

export type ContactInfoState = string | null;

const initialState: ContactInfoState = null;

export default function reducer(
  state: ContactInfoState = initialState,
  action: ParticipantAction | ContractAuthenticationAction
) {
  switch (action.type) {
    case CONTRACT_AUTHENTICATION_INITIALIZE:
      return initialState;
    case PARTICIPANT_STATUS_SUCCESS:
      return action.payload.signer.contactInfo || state;
    case PARTICIPANT_SET_INFORMATION:
      return action.payload.contactInfo || state;
    default:
      return state;
  }
}
